<template>
    <div>
        <form class="payment-form" v-if=" showFormInformations ">

            <!-- Civilite -->
            <div class="element-wrap element-wrap-for-select element-wrap-on-left">
                <div class="element-label">
                    <span>Vous êtes ?</span>
                </div>
                <select class="element-is-select" name="civilite" v-model="value.civilite">
                    <option value="" selected>
                        Sélectionnez une civilité
                    </option>
                    <option value="Monsieur">
                        Monsieur
                    </option>
                    <option value="Madame">
                        Madame
                    </option>
                    <option value="Mademoiselle">
                        Mademoiselle
                    </option>
                </select>
            </div>
            <!-- Civilite -->

            <!-- Nom & Prenom(s) -->
            <div class="element-pair mt-4">
                <div class="element-pair-container">
                    <div class="element-wrap element-wrap-on-left">
                        <div class="element-label">
                            <span>Nom</span>
                        </div>
                        <input type="text" class="element-is-input" name="name" v-model="value.nom"/>
                    </div>
                    <div class="element-wrap element-wrap-on-right">
                        <div class="element-label">
                            <span>Prénom</span>
                        </div>
                        <input type="text" class="element-is-input" name="prenom" v-model="value.prenom"/>
                    </div>
                </div>
            </div>
            <!-- Nom & Prenom(s) -->

            <!-- Numero de telephone -->
            <div class="element-pair mt-4" style="margin-top: 15px;">
                <div class="element-label">
                    <span>Numéro de téléphone</span>
                </div>
                <div class="element-pair-container">
                    <div class="element-wrap element-wrap-on-left">
                        <multiselect
                                v-model="value2.i"
                                :options="pays"
                                :multiple="false"
                                placeholder="Indicatif"
                                tag-placeholder="Indicatif"
                                track-by="code"
                                label="country"
                                :searchable="true"
                                :select-label="''"
                                :deselect-label="''"
                                :selected-label="'✓'"
                                :allow-empty="false"
                        >
                            <template slot="singleLabel" slot-scope="{ option }">{{ option.country_code }}</template>
                            <span slot="noResult"></span>
                        </multiselect>
                    </div>
                    <div class="element-wrap element-wrap-on-right">
                        <input
                                class="element-is-input"
                                type="tel"
                                v-mask="'## ## ## ## ##'"
                                name="telephone"
                                v-model="value.telephone"
                                style="font-weight: 900; font-size: 22px"
                        />
                    </div>
                </div>
            </div>
            <!-- Numero de telephone -->

            <!-- Date de naissance -->
            <div class="element-wrap element-wrap-on-left">
                <div class="element-label">
                    <span>Date de naissance</span>
                </div>
                <!-- <input type="date" class="element-is-input" name="date" v-model="value.dateNaissance"/> -->
                <datepicker class="element-is-input" v-model="value.dateNaissance" format="yyyy-MM-dd" :disabledDates="disabledDates" :language="fr"></datepicker>
            </div>
            <!-- Date de naissance -->

            <!-- Pays de naissance et Nationalité -->
            <div class="element-pair mt-4">
                <div class="element-pair-container">
                    <div class="element-wrap element-wrap-for-select element-wrap-on-left">
                        <div class="element-label">
                            <span>Pays de naissance</span>
                        </div>
                        <select class="element-is-select" name="country" v-model="value.paysNaissance">
                            <option value="" disabled>
                                Sélectionnez un pays
                            </option>
                            <option v-for="(country, index) in pays" :key="index" :value="country.name">
                                {{ country.name }}
                            </option>
                        </select>
                    </div>
                    <div class="element-wrap element-wrap-for-select element-wrap-on-right">
                        <div class="element-label">
                            <span>Nationalité</span>
                        </div>
                        <select class="element-is-select" name="country"  v-model="value.nationalite">
                            <option value="" selected disabled>
                                Sélectionnez un pays
                            </option>
                            <option v-for="(country, index) in pays" :key="index" :value="country.name">
                                {{ country.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <!-- Pays de naissance et Nationalité -->

            <!-- Email et Profession -->
            <div class="element-pair mt-4">
                <div class="element-pair-container">
                    <div class="element-wrap element-wrap-on-left">
                        <div class="element-label">
                            <span>E-mail</span>
                        </div>
                        <input type="email" class="element-is-input" name="email" v-model="value.email"/>
                    </div>
                    <div class="element-wrap element-wrap-on-right">
                        <div class="element-label">
                            <span>Profession</span> (Optionnel)
                        </div>
                        <input type="text" class="element-is-input" name="profession" v-model="value.profession"/>
                    </div>
                </div>
            </div>
            <!-- Pays de naissance et Nationalité -->

            <!-- Adresse et Ville -->
            <div class="element-pair mt-4">
                <div class="element-pair-container">
                    <div class="element-wrap element-wrap-on-left">
                        <div class="element-label">
                            <span>Adresse</span> (Optionnel)
                        </div>
                        <input type="text" class="element-is-input" name="address" v-model="value.adresse"/>
                    </div>
                    <div class="element-wrap element-wrap-on-right">
                        <div class="element-label">
                            <span>Ville</span> (Optionnel)
                        </div>
                        <input type="text" class="element-is-input" name="city" v-model="value.ville"/>
                    </div>
                </div>
            </div>
            <!-- Adresse et Ville -->

            <!-- Choix de livraison -->
            <div class="element-pair mt-4">
                <div class="element-pair-container">
                    <div class="element-wrap element-wrap-for-select element-wrap-on-left">
                        <div class="element-label">
                            <span>Choix de livraison</span>
                        </div>
                        <select class="element-is-select" name="delivery-choice" v-model="value.choixLivraison">
                            <option value="" selected disabled>
                                Sélectionnez une réponse
                            </option>
                            <option value="Agence">
                                Livraison dans une agence Weblogy
                            </option>
                            <option value="Domicile">
                                Livraison à domicile
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <!-- Choix de livraison -->

            <!-- Lieu de livraison - Agences Weblogy -->
            <div class="element-pair mt-4" v-if=" value.choixLivraison == 'Agence' ">
                <div class="element-pair-container">
                    <div class="element-wrap element-wrap-for-select element-wrap-on-left">
                        <div class="element-label">
                            <span>Choix de l'agence Weblogy</span>
                        </div>
                        <select class="element-is-select" name="delivery" v-model="value.lieuLivraison">
                            <option value="" selected disabled>
                                Sélectionnez une agence
                            </option>
                            <option value="1">Agence siège Weblogy Plateau</option>
                            <option value="2">Agence siège Weblogy Cocody</option>
                            <!-- <option value="3">Agence Weblogy Radisson</option> -->
                            <option value="4">Agence Weblogy Zone 4</option>
                        </select>
                    </div>
                </div>
            </div>
            <!-- Lieu de livraison - Agences Weblogy -->

            <div class="element-pair mt-4 row">

                <div class="col-lg-12 col-md-12" style="display: block; line-height: 1.8" v-if="value.lieuLivraison == '1'">
                    <div class="text-left">
                        <p style="font-size: 14px">
                            Rendez-vous à l'agence de Plateau pour récupérer votre commande. <br>
                            <strong>Plateau pyramide, rue BCEAO, après le pullman hôtel. Résidence PELIEU 2e étage.</strong>
                            <br>
                            <a href="tel:002252720334952" style="color: #0e2abd"><i class="fa fa-phone"></i>&nbsp; +225 27 20 334 952</a>
                        </p>
                    </div>
                    <div class="text-left">
                        <p style="font-size: 14px">
                            Horaires : Lundi - Vendredi : 08h - 18h / Samedi : 09h - 13h
                        </p>
                    </div>
                </div>

                <div class="col-lg-12 col-md-12" style="display: block; line-height: 1.8" v-if="value.lieuLivraison == '2'">
                    <div class="text-left">
                        <p style="font-size: 14px">
                            Rendez-vous à l'agence de Cocody pour récupérer votre commande. <br>
                            <strong>Cocody Ambassade, Rue Booker Washington près du cabinet children of Africa.</strong>
                            <br>
                            <a href="tel:002252522010114" style="color: #0e2abd"><i class="fa fa-phone"></i>&nbsp; +225 25 22 010 114</a>
                        </p>
                    </div>
                    <div class="text-left">
                        <p style="font-size: 14px">
                            Horaires : Lundi - Samedi : 08h00 - 21h00 / Dimanche : 13h00 - 20h00
                        </p>
                    </div>
                </div>

                <div class="col-lg-12 col-md-12" style="display: block; line-height: 1.8" v-if="value.lieuLivraison == '3'">
                    <div class="text-left">
                        <p style="font-size: 14px">
                            Rendez-vous à l'agence de Radisson pour récupérer votre commande. <br>
                            <strong>Cocody Ambassade, Rue Booker Washington près du cabinet children of Africa</strong>
                            <br>
                            <a href="tel:002252522010114" style="color: #0e2abd"><i class="fa fa-phone"></i>&nbsp; +225 25 22 010 114</a>
                        </p>
                    </div>
                    <div class="text-left">
                        <p style="font-size: 14px">
                            Horaires : Lundi - Samedi : 08h00 - 21h00 / Dimanche : 09h00 - 17h00
                        </p>
                    </div>
                </div>

                <div class="col-lg-12 col-md-12" style="display: block; line-height: 1.8" v-if="value.lieuLivraison == '4'">
                    <div class="text-left">
                        <p style="font-size: 14px">
                            Rendez-vous à l'agence de Zone 4 pour récupérer votre commande. <br>
                            <strong>Marcory Zone 4 immeuble pistache et chocolat.</strong>
                            <br>
                            <a href="tel:002252521006088" style="color: #0e2abd"><i class="fa fa-phone"></i>&nbsp; +225 25 21 006 088</a>
                        </p>
                    </div>
                    <div class="text-left">
                        <p style="font-size: 14px">
                            Horaires : Lundi - Vendredi : 08h - 18h / Samedi : 09H - 13H
                        </p>
                    </div>
                </div>

            </div>


            <!-- Lieu de livraison - Domicile -->
            <div class="element-pair mt-4" v-if=" value.choixLivraison == 'Domicile' ">
                <div class="element-pair-container">
                    <div class="element-wrap element-wrap-on-left">
                        <div class="element-label">
                            <span>Lieu de livraison</span>
                        </div>
                        <textarea rows="3" type="text" class="element-is-input" name="city" v-model="value.lieuLivraison"></textarea>
                    </div>
                </div>
            </div>
            <!-- Lieu de livraison - Domicile -->


            <!-- Buttons -->
            <div class="mt-5" style="display: flex; justify-content: space-between; align-items: center;">

                <i class="fas fa-arrow-left font-18 text-dark" @click="validerLeChoixDesCartes" style="cursor: pointer;"></i>

                <button
                        type="button" @click="formIdentificationNext2"
                        :disabled=" !value.civilite || !value.nom || !value.prenom || !value.telephone || !value.dateNaissance || !value.paysNaissance || !value.nationalite || !value.email || !value.choixLivraison "
                        :class=" !value.civilite || !value.nom || !value.prenom || !value.telephone || !value.dateNaissance || !value.paysNaissance || !value.nationalite || !value.email || !value.choixLivraison ?
                                    'btn btn-sm btn-dark btn-disabled-custom font-14' : 'btn btn-sm btn-dark font-14' "
                        style="font-weight: bold;"
                >
                    Suivant
                </button>
            </div>
            <!-- Buttons -->

        </form>
    </div>
</template>

<script>

    import Multiselect from "vue-multiselect" ;
    import Datepicker from 'vuejs-datepicker';
    import {fr} from 'vuejs-datepicker/dist/locale';

    export default {
        components:{
            multiselect: Multiselect,
            'datepicker': Datepicker
        },
        data() {
            return {
                fr: fr,
                format: "yyyy-MM-dd",
                disabledDates: {
                    // to: new Date(2023, 0, 1), // Disable all dates up to specific date
                    // from: new Date(2023, 0, 31), // Disable all dates after specific date
                    // to: new Date(Date.now() - 8640000)
                    from: new Date()
                }
            }
        },
        props: {
            value: {
                type: Object
            },
            value2: {
                type: Object
            },
            showFormInformations : {
                type: Boolean
            },
            validerCartes: { type: Function },
            formIdentificationNext : { type: Function },
            pays:{ type: Array }
        },
        mounted(){
            // console.log(value.dateNaissance)
        },
        methods: {

            validerLeChoixDesCartes()
            {
                this.validerCartes();
            },

            formIdentificationNext2()
            {
                this.formIdentificationNext() ;
            },

        },
        watch: {

            value() {
                this.$emit('input', this.value);
            },

            value2() {
                this.$emit('input', this.value2);
            },


        }
    }
</script>

<style scoped>

    table { width:100%; }
    .intitule { font-weight:normal; color:#333;}

    .pos-relative{
        position: relative;
    }

    .pos-relative .line {
        position: relative;
        padding-top: 20px;
    }

    .pos-relative .line:after {
        content: "";
        position: relative;
        left: 40%;
        width: 20%;
        height: 2px;
        background: #faaa13;
        top: -115px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
    }

    .pos-relative2{
        position: relative;
    }

    .pos-relative2 .line2 {
        position: relative;
        padding-top: 50px;
    }

    .pos-relative2 .line2:after {
        content: "";
        position: absolute;
        left: 40%;
        width: 20%;
        height: 4px;
        background: #dfe2e5;
        top: 20px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        /*border-radius: 20px;*/
    }

    .floating-container {
        position: fixed;
        width: auto;
        /* height: 100px; */
        bottom: 40px;
        right: 0;
        margin: 30px 25px;
        z-index: 20;
    }

    .custom-shadow{
        box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px !important;
    }

    .content {
        position: relative;
        width: 100%;
        max-width: 400px;
        margin: auto;
        overflow: hidden;
    }

    .custom-rounded {
        border-radius: 32px;
    }

    .shadow{
        box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px !important;
        border-radius: 20px;
    }

    .menu-cabine {
        /* padding: 28px; */
        /* margin: 0 auto; */
        /*cursor: pointer;*/
    }

    .menu-cabine:hover, .menu-cabine:focus{
        /* padding: 28px; */
        /* margin: 0 auto; */
        /*cursor: pointer;*/
        /* border-radius: 5px; */
        /* box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px; */
    }

    /*.content .content-overlay {*/
    /*    background: rgba(0,0,0,0.7);*/
    /*    position: absolute;*/
    /*    height: 100%;*/
    /*    width: 100%;*/
    /*    left: 0;*/
    /*    top: 0;*/
    /*    bottom: 0;*/
    /*    right: 0;*/
    /*    opacity: 0;*/
    /*    -webkit-transition: all 0.5s ease-in-out 0s;*/
    /*    -moz-transition: all 0.5s ease-in-out 0s;*/
    /*    transition: all 0.5s ease-in-out 0s;*/
    /*    border-radius: 14px;*/
    /*}*/

    /*.content:hover .content-overlay{*/
    /*    opacity: 1;*/
    /*}*/



    .content-overlay:hover{
        transition: all 0.3s;
        border-color: #faaa13;
        border-style: solid;
        border-width: 2px;
        /*padding: 8px;*/
        border-radius: 25px;
        /*box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px !important;*/
    }

    .content-image{
        width: 100%;
    }

    .content:hover .content-details{
        top: 50%;
        left: 50%;
        opacity: 1;
    }

    .content-details {
        position: absolute;
        text-align: center;
        padding-left: 1em;
        padding-right: 1em;
        width: 100%;
        top: 50%;
        left: 50%;
        opacity: 0;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        -webkit-transition: all 0.3s ease-in-out 0s;
        -moz-transition: all 0.3s ease-in-out 0s;
        transition: all 0.3s ease-in-out 0s;
    }

    .fadeIn-top{
        top: 20%;
    }

    .content-details h3{
        color: #fff;
        font-weight: 500;
        letter-spacing: 0.15em;
        margin-bottom: 0.5em;
        text-transform: uppercase;
    }

    .content-details p{
        color: #fff;
        font-size: 0.8em;
    }

    .show-selected-mode{
        position: absolute;
        /*right: 3px;*/
        /*top: -6px;*/
        right: 17px;
        top: 18px;
        background: white;
        border-radius: 50%;
        z-index: 10;
    }

    .show-selected-mode2{
        position: absolute;
        right: 3px;
        top: -9px;
        /*right: 20px;*/
        /*top: 8px;*/
        background: white;
        border-radius: 50%;
        z-index: 10;
    }

    .btn-disabled-custom {
        background: rgb(0 0 0 / 8%);
        border: rgb(0 0 0 / 8%);
        color: #1b1e21;
        cursor: not-allowed;
    }

    .mode-rechargement {
        display: flex;
        flex-direction: column;
        cursor: pointer;
    }

    @media (max-width: 767px) {
        .content {
            width: 80%;
        }
        .show-selected-mode{
            right: 44px;
        }
    }

    .searchIcon {
        margin-left: -35px;
        cursor: pointer;
        /* color: #261b64; */
        color: #343a40;
        cursor: pointer;
        font-size: 25px;
        z-index: 50;
    }

</style>